var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembershipCancellation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_1831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3313 14.1562H12.1438V11.3438H6.5188V16.9688H9.3313V14.1562Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2688 16.9688H43.0813V11.3438H37.4563V14.1562H40.2688V16.9688Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2688 33.8438H37.4563V36.6562H43.0813V31.0312H40.2688V33.8438Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3313 31.0312H6.5188V36.6562H12.1438V33.8438H9.3313V31.0312Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 18.4201L25.8817 5.71875H0.800049V42.2812H21.9112L26.0946 29.7327L20.4375 18.4201ZM19.8841 39.4688H3.61255V8.53125H21.6162L17.9997 16.9688H12.1438V19.7812H17.9736L19.3801 22.5938H12.1438V25.4062H20.7865L22.193 28.2188H12.1438V31.0312H22.697L19.8841 39.4688Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9415 5.71875L23.5376 18.3299L29.1306 29.5173L24.8763 42.2812H48.8V5.71875H28.9415ZM45.9875 39.4688H28.7784L31.5906 31.0312H37.4563V28.2188H31.6258L30.2197 25.4062H37.4563V22.5938H28.8137L27.4076 19.7812H37.4563V16.9688H27.1807L30.7962 8.53125H45.9875V39.4688Z",
    fill: "#19A69D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_1831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.800049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipCancellation);
export default __webpack_public_path__ + "static/media/membership-cancellation.dd9a29c016610d1266ede796c3a442ea.svg";
export { ForwardRef as ReactComponent };